const CURRENCIES = {
  // TODO: plurialization long if it will use
  EUR: { symbol: '€', long: 'Euro', abbr: 'EUR' },
  USD: { symbol: '$', long: 'Dollar', abbr: 'USD' },
  GBP: { symbol: '£', long: 'Livre', abbr: 'GBP' },
}

export default CURRENCIES
